export const enum ClientPurchaseOrderStatusConstant {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  VOID = 'VOID',
  ACTIVE_FOR_APPROVAL = '2',
  DRAFT_FOR_APPROVAL = '3',
  ESTIMATE = 'ESTIMATE',
}

export const ClientPurchaseOrderStatusTextConstant :any = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
  VOID: 'VOID / CANCELLED',
  ACTIVE_FOR_APPROVAL: 'ACTIVE (For Approval)',
  DRAFT_FOR_APPROVAL: 'DRAFT (For Approval)',
  ESTIMATE: 'ESTIMATE',
};

export enum ClientPurchaseOrderOverriden {
  NOT_OVERRIDEN = 0,
  OVERRIDEN = 1,
}

export enum ClientPurchaseOrderOverrideApprove {
  PENDING_APPROVAL = 0,
  APPROVED = 1,
  DECLINED = 2,
}

export enum ClientPurchaseOrderApprovalStatus {
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  APPROVAL_REQUIRED = 'APPROVAL_REQUIRED',
}

export enum ClientPurchaseOrderCreatedFrom {
  LUMINOUS = 'LUMINOUS',
  B2BPORTAL = 'B2BPORTAL',
}

export class ClientContactNotificationConstant {
  public static RECEIVE_QUOTATION_PDF = 'receive_quotation_pdf';
  public static RECEIVE_PURCHASE_ORDER_PDF = 'receive_purchase_order_pdf';
  public static RECEIVE_PURCHASE_ORDER_INVOICE_PDF =
    'receive_purchase_order_invoice_pdf';
}
